export type Phase = 'p1' | 'p2' | 'p3';
const timelineData = {
  start: '2025-04-08T18:00:00.000Z',
  p1: '2025-04-08T20:02:18.000Z',
  p2: '2025-04-08T20:14:32.000Z',
  p3: '2025-04-08T20:18:15.000Z',
  end: '2025-04-08T20:30:00.000Z',
};
const dictionaryShort = {
  start: 'Start',
  p1: 'Start przelotu',
  p2: 'Max przelotu',
  p3: 'Koniec przelotu',
};

const dictionaryLong = {
  p1: 'początek przelotu satelity Ajisai',
  p2: 'maksimum przelotu satelity Ajisai',
  p3: 'koniec przelotu satelity Ajisai',
};

const PHASES: Phase[] = ['p1', 'p2', 'p3'];

export {
  timelineData, dictionaryShort, dictionaryLong, PHASES,
};
